<template>
  <div class="district-mangement">
    <div class="district-mangement-left">
      <left-tree @changeSwitch="changeSwitch" @nodeClick="nodeClick"></left-tree>
    </div>
    <div class="district-mangement-right">
      <TabelSearch :searchConfig="searchConfig" :searchParams="searchParams" @resetCallBack="resetCallBack"
                   @search="setSearchParams"></TabelSearch>
      <Table :width="'100%'" :tableLoading="tableLoading" :tabelButtons="tabelButtons" :templateData="tableTemplateData"
             :tableConfig="tableConfig" :pagination="pagination">
      </Table>
    </div>
    <el-dialog custom-class="dialog-table" :close-on-click-modal="false" :close-on-press-escape="false" title="查看"
               :visible.sync="dialogVisible2" width="40%" :before-close="handleClose2">
      <Table :width="'100%'" :tableLoading="tableLoading2" :tabelButtons="tabelButtons2"
             :templateData="tableTemplateData2" :tableConfig="tableConfig2" :pagination="pagination2"></Table>
    </el-dialog>
    <el-dialog custom-class="dialog-table" :close-on-click-modal="false" :close-on-press-escape="false" title="绑定用户"
               :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
      <div class="space-between" style="height: 650px">
        <div class="left" style="height: 95%">
          <Tree :showSwitch="false" :isfirstChoice="false" :showCheckbox="true"
                :areaTags="applyTag" :title="'指挥中心'" :switchVal="false" @nodeClick="nodeClick2"></Tree>
        </div>
        <div class="right" style="flex: 1;margin-left: 10px">
          <div class="">已选择地区:</div>
          <div class="areaAccredit">
            <el-tag
                v-for="(tag) in areaTags"
                :key="tag.name" style="margin-right: 10px;margin-bottom: 10px"
                closable @close="closable(tag)"
                :type="tag.type">
              {{ tag.name }}
            </el-tag>
          </div>
          <div style="height: 70%;padding-top:10px;display:flex;flex-direction: column;">
            <TabelSearch :searchConfig="searchConfig3" :searchParams="searchParams3" @resetCallBack="resetCallBack2"
                         @search="setSearchParams2"></TabelSearch>
            <Table :width="'100%'" :tableLoading="tableLoading3" :templateData="tableTemplateData3"
                   :tableConfig="tableConfig3" :pagination="pagination3"></Table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title" center
               :visible.sync="dialogVisible4" width="400px" :before-close="handleClose4">
      <div class="space-between">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户" v-if="!isBatch" prop="userName">
            <el-input v-model="ruleForm.userName" disabled></el-input>
          </el-form-item>
          <el-form-item label="申请备注" v-if="!isBatch" prop="applicationNote">
            <el-input type="textarea" disabled v-model="ruleForm.applicationNote"></el-input>
          </el-form-item>
          <el-form-item label="审核备注" prop="text">
            <el-input type="textarea" v-model="ruleForm.text"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="handleClose4">取 消</el-button>
				<el-button type="danger" @click="audit(2)">拒 绝</el-button>
				<el-button type="primary" @click="audit(1)">通 过</el-button>
			</span>
    </el-dialog>

  </div>
</template>

<script>
import Tree from '../../../../components/Tree/nodeTreeUser';
import leftTree from '../../../../components/Tree/nodeTree';
import Table from "../../../../components/table/table";
// import editForm from '../../../../components/edit-form/edit-form';
import TabelSearch from '../../../../components/tabel-search/tabel-search';
import {userApi} from '../../../../api-path/user-api';
import publicAPI from "../../../../api-path/public-api";
import {systemApi} from "@/api-path/system-api";

export default {
  name: "regional-authorized",
  components: {
    Tree, Table, TabelSearch, leftTree
  },
  data() {
    return {
      applyTag: [],
      //search
      isDown: false,
      searchParams: {
        areaId: '',
        applicationStatus: null,
        status: '0',//授权状态 默认申请中
        tags: '',
        page: 1,
        size: 15,
      },
      userId: [],
      setParams: {
        userId: '',
        page: 1,
        size: 10,
      },
      searchConfig: {
        dataName: 'searchParams',
        items: [{
          key: 'tags',
          valueType: 'text',
          placeholder: '输入姓名/手机号搜索',
        }, {
          key: 'status',
          valueType: 'select',
          placeholder: '授权状态',
          option: {
            label: 'itemName',
            value: 'itemValue'
          },
          path: publicAPI.queryByCodeValue + '/AREA_AUTH_STATUS'
        }]
      },
      // table
      tableLoading: false,
      tableLoading2: false,
      tabelButtons: [
        {
          type: 'bindUser',
          title: '绑定用户',
          fn: () => {
            this.dialogVisible = true;
            this.title = '绑定用户'
            this.startSearch3();
          }
        },
        {
          type: 'batchAudit',
          title: '批量审核',
          fn: (data) => {
            data.map(item => {
              this.userId.push(item.id)
            })
            this.title = '批量审核'
            this.dialogVisible4 = true;
            this.isBatch = true;
          }
        },

        {
          type: "delete", //删除
          path: userApi.areaApplyDel,
          paramsName: "ids:id",
          hintMessage: "是否删除所选信息？ 删除后将无法恢复，请谨慎操作",
          fn: this.startSearch,
        },


      ],
      tabelButtons2: [],
      tableTemplateData: [],
      tableTemplateData2: [],
      tableConfig: {
        checkbox: true,
        index: true,
        checkboxFn: () => {
        },
        rows: [{
          label: '手机号',
          prop: 'phone',
        }, {
          label: '真实姓名',
          prop: 'realName',
        }, {
          label: '申请区域',
          prop: 'areaName',
        }, {
          label: '申请备注',
          prop: 'text',
          type: "popover",
          width: '150px',
        }, {
          label: '审核备注',
          prop: 'auditOpinion',
          type: "popover",
          width: '150px',
        }, {
          label: '授权状态',
          prop: 'status',
          type: 'activeStatus',
          fn: (data) => {
            let result = data.status == 0 ? '申请中' : data.status == 1 ? '已通过' : data.status == 2 ? '已拒绝' : data.status == 3 ? '已解绑' : '手动授权';
            return result;
          }
        }],
        rowButtons: {
          width: '240px',
          items: [
            // {
            // 	show: "status===1? true : false",
            // 	label: '解绑',
            // 	fn: (data) => {
            // 		this.$confirm('确定要接触绑定此授权？, 是否继续?', '授权提示', {
            // 			confirmButtonText: '确定',
            // 			cancelButtonText: '取消',
            // 			type: 'warning'
            // 		}).then(() => {
            // 			let declare={id:data.id,ids:[data.userId],status:3,text:null}
            // 			this.$http.post(userApi.areaCheck,declare).then(res=>{
            // 				if(res.status===200){
            // 					this.$message.success('解除绑定成功');
            // 					this.startSearch(this.searchParams)
            // 				}
            // 			})
            // 		}).catch(() => {});
            // 	},
            // },
            {
              label: '查看',
              fn: (data) => {
                this.tableLoading2 = true;
                this.setParams.userId = data.userId;
                this.authAreaByUserIdApply();
                this.dialogVisible2 = true;
              }
            },
            {
              label: '审核',
              type: 'success',
              show: "status===0? true : false",
              fn: (data) => {
                this.isBatch = false;
                this.title = '用户审核'
                this.ruleForm.id = data.id;
                this.userId = [data.userId];
                this.dialogVisible4 = true;
                this.ruleForm.userName = data.realName;
                this.ruleForm.applicationNote = data.text;
              },
            },

            {
              label: '删除',
              // code:'del',
              type: 'danger',
              fn: (data) => {
                this.delData(data.id)
              },
            },
          ],
        },
      },

      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      tableConfig2: {
        checkbox: false,
        index: true,
        rows: [{
          label: '授权区域',
          prop: 'areaName',
        }],
        rowButtons: {
          width: '300px',
          items: [
            {
              label: '解绑用户',
              fn: (data) => {
                this.$confirm('确定要接触绑定此授权？, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  let declare = {id: data.id, ids: [data.userId], status: 3, text: null}
                  this.$http.post(userApi.areaCheck, declare).then(res => {
                    if (res.status === 200) {
                      this.authAreaByUserIdApply();
                      this.$message.success('解除绑定成功');
                      this.handleClose2();

                    }
                  })
                }).catch(() => {
                });
              }
            },
          ],
        },
      },
      pagination2: {
        show: true,
        total: 0,
        page: 1,
        size: 10,
        sizeChange: this.sizeChange2,
        pageChange: this.pageChange2,
      },
      //alert-dialog
      areaTags: [],
      title: '',
      dialogVisible: false,
      dialogVisible2: false,//查看绑定
      tableLoading3: false,//用户绑定
      tableTemplateData3: [],
      tabelButtons3: [],
      tableConfig3: {
        checkbox: false,
        index: true,
        rows: [{
          label: '手机号',
          prop: 'phone',
        }, {
          label: '授权区域',
          prop: 'areaName',
        }, {
          label: '真实姓名',
          prop: 'realName',
        }, {
          label: '角色',
          prop: 'userTypeName',
        }],
        rowButtons: {
          width: '100px',
          items: [
            {
              label: '授权',
              fn: (data) => {
                if (this.areaTags.length === 0) {
                  this.$message.error('请选择要授权的区域');
                  return false
                }
                this.$confirm('确定要为该用户授权已选的区域？, 是否继续?', '授权提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  let ids = [];
                  this.areaTags.forEach(res => {
                    ids.push(res.id)
                  });
                  this.$http.post(userApi.areaApply, {id: data.id, ids: ids, status: 4, text: '',}).then(res => {
                    if (res.status == 200) {
                      this.$message.success('授权成功！')
                    }
                  })
                }).catch(() => {
                });
              }
            },
          ],
        },
      },
      searchConfig3: {
        dataName: 'searchParams3',
        items: [
          {
            valueType: 'tree-selected',
            key: 'areaName', // 数据名称
            prop: 'areaName', // 验证规则
            placeholder: '请选择所属辖区', // 提示信息
            fn: (data) => { //选择的值
              this.searchParams3.areaName = data.name;
              this.searchParams3.areaId = data.areaId;
            }
          },
          {
            key: 'nameOrPhone',
            valueType: 'text',
            placeholder: '输入姓名/手机号搜索',
          }
        ]
      },
      pagination3: {
        show: true,
        total: 0,
        page: 1,
        size: 5,
        pageSizes: [5],
        sizeChange: this.sizeChange3,
        pageChange: this.pageChange3,
      },
      searchParams3: {
        areaId: '',
        areaName: '',
        status: '',//授权状态
        nameOrPhone: '',
        isDown: true,
        page: 1,
        size: 5,
      },
      //	审核和批量审核
      isBatch: false,
      dialogVisible4: false,
      ruleForm: {
        userName: '',//用户
        applicationNote: '',//申请备注
        status: '',//状态
        text: '', //审核备注
      },
      rules: {
        areaParent: [{required: true, message: '请选择父级区域', trigger: 'blur'}],
        areaName: [{required: true, message: '请输入区域名称', trigger: 'blur'}],
      },
    }
  },
  methods: {

    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch(this.searchParams)
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page
      this.searchParams.page = page;
      this.startSearch(this.searchParams);
    },
    changeSwitch(e) {
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch(this.searchParams);
    },
    nodeClick(node) {
      this.areaId = node.id;
      this.areaName = node.id ? node.name : "";
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.areaId = node.id;
      this.searchParams3.areaId = node.id;
      this.searchParams3.areaName = node.name;
      this.startSearch(this.searchParams);
    },
    startSearch() {
      this.tableLoading = true;
      this.$http.get(userApi.areaApplyList, {params: this.searchParams}).then(res => {
        this.tableLoading = false;
        if (res.status == 200) {
          this.tableTemplateData = res.result.pageList
          this.pagination.total = res.result.total;
          if (this.searchParams.status === '0') {
            this.tabelButtons = [
              {
                type: 'bindUser',
                title: '绑定用户',
                fn: () => {
                  this.dialogVisible = true;
                  this.title = '绑定用户'
                  this.startSearch3();
                }
              },
              {
                type: 'batchAudit',
                title: '批量审核',
                fn: (data) => {
                  data.map(item => {
                    this.userId.push(item.id)
                  })
                  this.title = '批量审核'
                  this.dialogVisible4 = true;
                  this.isBatch = true;
                }
              },
            ]
          } else if (this.searchParams.status == '1') {
            this.tabelButtons = [
              {
                type: 'bindUser',
                title: '绑定用户',
                fn: () => {
                  this.dialogVisible = true;
                  this.title = '绑定用户'
                  this.startSearch3();
                }
              },
              {
                type: 'batchAudit',
                title: '解绑',
                fn: (data) => {
                  let ids = data.map(item => {
                    return item.id;
                  })
                  this.$confirm('确定要解除绑定？, 是否继续?', '授权提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    let declare = {ids: ids, status: 3, text: null}
                    this.$http.post(userApi.areaCheck, declare).then(res => {
                      if (res.status === 200) {
                        this.$message.success('解除绑定成功');
                        this.startSearch(this.searchParams)
                      }
                    })
                  }).catch(() => {
                  });
                }
              },
            ]
          } else {
            this.tabelButtons = [
              {
                type: 'bindUser',
                title: '绑定用户',
                fn: () => {
                  this.dialogVisible = true;
                  this.title = '绑定用户'
                  this.startSearch3();
                }
              }
            ]
          }
        }
      })
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.startSearch(this.searchParams)

    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.tags = '';
      this.searchParams.status = '';
      this.searchParams.isDown = this.isDown;
      this.searchParams.areaId = this.areaId;
      this.startSearch(this.searchParams)
    },
    handleClose() {
      this.dialogVisible = false;
      this.areaTags = [];
      this.applyTag = [];
      this.startSearch(this.searchParams)
    },
    authorizationConfirm() {

    },
    handleClose2() {
      this.dialogVisible2 = false;
      this.startSearch(this.searchParams)
    },


    //授权区域
    pageChange2(page) {
      this.pagination2.page = page
      this.setParams.page = page;
      this.authAreaByUserIdApply()
    },

    // 授权区域
    sizeChange2(size) {
      this.pagination2.size = size;
      this.setParams.size = size;
      this.authAreaByUserIdApply()
    },


    //用户绑定
    pageChange3(page) {
      this.pagination3.page = page
      this.searchParams3.page = page;
      this.startSearch3()
    },

    // 每页显示条数
    sizeChange3(size) {
      this.pagination3.size = size;
      this.searchParams3.size = size;
      this.startSearch3()
    },
    authAreaByUserIdApply() {
      this.$http.get(userApi.authAreaByUserIdApply, {params: this.setParams}).then(res => {
        this.tableLoading2 = false;
        if (res.status == 200) {
          this.tableTemplateData2 = res.result.pageList;
          this.pagination2.total = res.result.total;
        }
      })
    },

    nodeClick2(node) {
      this.areaTags = node;
      this.applyTag = node;
      // if(node.id){
      // 	let arr =this.areaTags.find((v) => {  return v.id == node.id; })
      // 	if(arr){return false}
      // 	else {this.areaTags.push(node)}
      // }

    },
    closable(tag) {
      this.areaTags.splice(this.areaTags.findIndex((el) => {
        return el.id === tag.id
      }), 1);
    },
    startSearch3() {
      this.$http.get(userApi.allUserAll, {params: this.searchParams3}).then(res => {
        if (res.status == 200) {
          this.tableTemplateData3 = res.result.pageList;
          res.result.pageList.forEach(item => {
            item.userTypeName = this.userTypest(item.userType)
          })
          this.pagination3.total = res.result.total;
        }
      })
    },
    userTypest(item) {
      let arr = [];
      item.split(',').forEach(it => {
        if (it == 1) {
          arr.push('接警员')
        }
        if (it == 2) {
          arr.push('出警员')
        }
        if (it == 3) {
          arr.push('区域权限')
        }
      })
      return arr.join(',')
    },
    resetCallBack2() {
      this.pagination3.page = 1;
      this.searchParams3.nameOrPhone = '';
      this.searchParams3.page = 1;
      this.startSearch3()
    },
    setSearchParams2(value) {
      if (value) {
        this.pagination3.page = value.page;
      }
      this.startSearch3()
    },
    //	审核和批量审核
    handleClose4() {
      this.dialogVisible4 = false
      this.ruleForm.text = '';
    },
    audit(isTrue) {
      if (this.isBatch) {
        let declare = {
          id: this.ruleForm.id,
          ids: this.userId,
          status: isTrue,
          text: this.ruleForm.text
        }
        if (isTrue == 2 && this.ruleForm.text == '') {
          this.$message.error('请填写审核备注！');
          return
        }
        this.$http.post(userApi.areaCheck, declare).then(res => {
          if (res.status === 200) {
            this.$message.success(this.title + '成功');
            this.startSearch(this.searchParams);
            this.userId = [];
            this.handleClose4()
          }
        })
      } else {
        let declare = {
          id: this.ruleForm.id,
          ids: this.userId,
          status: isTrue,
          text: this.ruleForm.text
        }
        if (isTrue == 2 && this.ruleForm.text == '') {
          this.$message.error('请填写审核备注！');
          return
        }
        this.$http.post(userApi.areaCheck, declare).then(res => {
          if (res.status === 200) {
            this.$message.success(this.title + '成功');
            this.startSearch(this.searchParams);
            this.userId = [];
            this.handleClose4()
          }
        })
      }

    },

    delData(id) {
      this.$confirm('确认删除区域认证?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let body = {
          "ids": [id]
        }
        this.$http.post(userApi.areaApplyDel, body).then((res) => {
          if (res.status == 200) {
            this.$message.success('刪除成功');
            this.startSearch()
          }
        })
      }).catch(() => {
      });
    },


  }
}
</script>

<style lang="less" scoped>
.dialog-table {
  .components-tabel {
    height: 500px;
  }
}


.district-mangement {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  overflow-x: auto;

  .district-mangement-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .areaAccredit {
    height: 10%;
    background: rgba(241, 246, 248, 1);
    padding: 10px;
    margin-top: 10px;
    overflow-y: auto;
  }

  .district-mangement-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .el-message-box {
    .el-message-box__input {
      .el-input {
        width: 100%;
      }
    }
  }
}
</style>
